import styled from "styled-components";

export const Hero = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  padding: 2rem 1rem;
  text-align: center;
  animation: fadeIn 0.8s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const Title = styled.h1`
  font-size: 2.25rem;
  color: var(--colorTitle);
  margin: 0;
  line-height: 1.05;
  font-weight: 700;

  @media (min-width: 768px) {
    font-size: 3rem;
  }
`;

export const Subtitle = styled.p`
  color: var(--textLight);
  max-width: 820px;
  margin: 0 auto;
  font-size: 1.05rem;
  line-height: 1.6;
`;

export const CTA = styled.div`
  display: flex;
  gap: 12px;

  justify-content: center;
  margin-top: 1rem;
  flex-wrap: wrap;
`;

export const Features = styled.ul`
  margin-top: 3rem;
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: left;

  @media (min-width: 768px) {
    gap: 1.5rem;
  }
`;

export const FeatureItem = styled.li`
  font-size: 1.125rem;
  color: var(--textLight);
`;
